import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';

import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import PinterestIcon from '@material-ui/icons/Pinterest';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';

import logo from '../assets/logo.png';

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.common.black,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        height: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        borderLeft: "2px solid #1e1e1e",
    },
    logoImage: {
        width: "90px",
        userSelect: "none",
        [theme.breakpoints.down("md")]: {
            width: "80px"
        },
    },
    logoTitle: {
        fontSize: "23px",
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "15px",
        },
    },
    logoSubtitle: {
        fontSize: "8.5px",
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "7px",
        },
    },
    title: {
        color: theme.palette.common.white,
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 2,
        fontSize: "1.2rem",
        fontWeight: 600,
        transition: "0.5s",
        textTransform: "capitalize",
    },
    subtitle: {
        color: theme.palette.common.gray,
        marginTop: "10px",
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 1,
        fontSize: "1rem",
        fontWeight: 300,
        transition: "0.5s",
    },
    menu: {
        cursor: "pointer",
        color: theme.palette.common.gray,
        marginTop: "10px",
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 1,
        fontSize: "1rem",
        fontWeight: 300,
        transition: "0.5s",
        "&:hover": {
            color: theme.palette.primary.main,
        }
    },
    icon: {
        color: theme.palette.common.gray,
    },
    copyRight: {
        color: theme.palette.common.gray,
        marginTop: "10px",
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 1,
        fontSize: "0.9rem",
        fontWeight: 300,
    },
    instagram: {
        cursor: "pointer",
        color: theme.palette.common.gray,
        marginTop: "10px",
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 1,
        fontSize: "1.8rem",
        fontWeight: 300,
        transition: "0.5s",
        "&:hover": {
            color: "#e4405f",
        }
    },
    facebook: {
        cursor: "pointer",
        color: theme.palette.common.gray,
        marginTop: "10px",
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 1,
        fontSize: "1.8rem",
        fontWeight: 300,
        transition: "0.5s",
        "&:hover": {
            color: "#3b5999",
        }
    },
    pinterest: {
        cursor: "pointer",
        color: theme.palette.common.gray,
        marginTop: "10px",
        lineHeight: 1.5,
        marginBottom: "10px",
        letterSpacing: 1,
        fontSize: "1.8rem",
        fontWeight: 300,
        transition: "0.5s",
        "&:hover": {
            color: "#bd081c",
        }
    },
    menuSelected: {
        color: theme.palette.primary.main,
        fontWeight:"bold"
    },
}))

export default function Footer(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory();

    const menuSelected = props.menuSelected;
    const setMenuSelected = props.setMenuSelected;

    const homeLink = () => {
        setMenuSelected("home");
    };
    const servicesLink = () => {
        setMenuSelected("services");
    };
    const projectsLink = () => {
        setMenuSelected("projects");
    };
    const aboutLink = () => {
        setMenuSelected("about");
    };
    const contactLink = () => {
        setMenuSelected("contact");
    };

    return (
        <React.Fragment >
            <Grid container direction="column" className={classes.container} >

                <Grid item container direction="row" justify="center" >

                    <Hidden smDown>
                        <Grid item md={4} sm={6} xs={6}>
                            <Grid item container direction="column" className={classes.box}>
                                <img src={logo} alt="Logo" className={classes.logoImage} />

                                <Grid item container direction="row" alignItems="center" spacing={2}>
                                    <Grid item >
                                        <Grid item container direction="column">
                                            <Grid item>
                                                <Typography variant="h1" style={{ color: theme.palette.common.white }} className={classes.logoTitle}>
                                                    Techno Construction, LLC
                                            </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="h2" style={{ color: theme.palette.common.white, letterSpacing: "3px", }} className={classes.logoSubtitle}>
                                                    A modern approach to your space planning
                                            </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Hidden>
                    <Grid item md={4} sm={6} xs={6} >
                        <Grid item container direction="column" className={classes.box} >
                            <Typography variant="h3" className={classes.title} style={{ marginTop: "10px", }}>
                                Site Menu
                            </Typography>
                            <Typography component={Link} href={"/"} style={{ textDecoration: "none" }} variant="h2" className={`${classes.menu} ` + `${menuSelected === "home" ? classes.menuSelected : null}`} onClick={homeLink}>
                                Home
                            </Typography>
                            <Typography component={Link} href={"/services"} style={{ textDecoration: "none" }} variant="h2" className={`${classes.menu} ` + `${menuSelected === "services" ? classes.menuSelected : null}`} onClick={servicesLink}>
                                Services
                            </Typography>
                            <Typography component={Link} href={"/projects"} style={{ textDecoration: "none" }} variant="h2" className={`${classes.menu} ` + `${menuSelected === "projects" ? classes.menuSelected : null}`} onClick={projectsLink}>
                                Projects
                            </Typography>
                            <Typography component={Link} href={"/about"} style={{ textDecoration: "none" }} variant="h2" className={`${classes.menu} ` + `${menuSelected === "about" ? classes.menuSelected : null}`} onClick={aboutLink}>
                                About
                            </Typography>
                            <Typography component={Link} href={"/contact"} style={{ textDecoration: "none" }} variant="h2" className={`${classes.menu} ` + `${menuSelected === "contact" ? classes.menuSelected : null}`} onClick={contactLink}>
                                Contact
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={4} sm={6} xs={6} >
                        <Grid item container direction="column" className={classes.box}>
                            <Typography variant="h3" className={classes.title} style={{ marginTop: "10px", }}>
                                Contact Us
                            </Typography>
                            <Grid item container direction="column" >

                                <Grid item >
                                    <Grid item container direction="row" alignItems="center" spacing={1}>
                                        <Grid item>
                                            <LocationOnOutlinedIcon className={classes.icon} />
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h2" className={classes.subtitle} >
                                                &nbsp;9446 Onion Patch Drive, <Hidden smUp><br />&nbsp;</Hidden>Burke, Virginia 22015
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item >
                                    <Grid item container direction="row" alignItems="center" spacing={1}>
                                        <Grid item>
                                            <MailOutlineOutlinedIcon className={classes.icon} />
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h2" className={classes.subtitle} >
                                                &nbsp;info@ultimatehdesign<Hidden smUp><br />&nbsp;</Hidden>.com
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <Grid item container direction="row" alignItems="center" spacing={1}>
                                        <Grid item>
                                            <SmartphoneOutlinedIcon className={classes.icon} />
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h2" className={classes.subtitle} >
                                                +1 (703) 929-6163
                                                <br />
                                                +1 (202) 909-6603
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <Grid item container direction="row" alignItems="center" spacing={2}>
                                        <Grid item>
                                            <Link color="inherit" href="https://www.instagram.com/ultimatehomedesign/" target="blank">
                                                <InstagramIcon className={classes.instagram} />
                                            </Link>
                                        </Grid>
                                        <Grid item>
                                            <Link color="inherit" href="https://www.facebook.com/Ultimatehomedesign" target="blank">
                                                <FacebookIcon className={classes.facebook} />
                                            </Link>
                                        </Grid>
                                        <Grid item>
                                            <Link color="inherit" href="https://www.pinterest.com/ultimatehomed" target="blank">
                                                <PinterestIcon className={classes.pinterest} />
                                            </Link>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item >
                    <Typography variant="h2" align="center" className={classes.copyRight} >
                        {'Copyright © Techno Construction, LLC. All rights reserved. Website Developed by '}
                        <Link color={"inherit"} href="https://fmcv.ir/" target="blank">
                            <span style={{ color: theme.palette.primary.main, fontWeight: "bold" }}>Fmcv.ir </span>
                        </Link>{' '}
                        {'2021'}
                        {'.'}
                    </Typography>
                </Grid>

            </Grid>
        </React.Fragment>

    );
}
